import { loadContent } from './utils/ajax';
import {
  formatText,
  cmsNoImage,
  contentToCollapse,
  scrollTo
} from './utils/general';
import {
  countCheckedParamFilters,
  switchProductListFeaturedImage,
  openFilterPanel,
  closeFilterPanel
} from './utils/webshop';
import tplWebshopProductList from './templates/webshop_product_list.pug';
import tplWebshopProductFilter from './templates/webshop_product_filter.pug';

const filterCollapseState = {}; // store opened collapse elements in filter

window.addEventListener('DOMContentLoaded', () => {

  const filterPanelEl = document.querySelector('[data-slot-product-list-filter]');

  // product filter event listeners
  setFilterListeners();

  if (filterPanelEl) {

    // mobile/destkop breakpoint changes:
    CMS.DataStore.subscribe('product_filter/bp_desktop', ({ match }) => {
      // auto-hide opened mobile filter on desktop
      if (match) {
        closeFilterPanel(filterPanelEl, { animation: false });
      }
    });
    CMS.watchBreakpoint('(min-width: 992px)', 'product_filter/bp_desktop', CMS.DataStore);
    
    // product filter category/subcategory changes
    CMS.DataStore.subscribe('product_filter/category', ({ uri, triggerEl, pushState, autoScroll }) => {
      if (typeof pushState === 'undefined') {
        pushState = true;
      }
      if (typeof autoScroll === 'undefined') {
        autoScroll = false;
      }
      if (triggerEl) {
        triggerEl.setAttribute('disabled', '');
      }

      // auto-scroll page
      if (autoScroll) {
        const productListEl = document.querySelector('[data-slot-product-list]');
        productListEl.style.minHeight = `${productListEl.getBoundingClientRect().height}px`;
        scrollTo('#titleProductList', {
          onComplete: () => {
            productListEl.style.minHeight = '';
          }
        });
      }

      loadContent(uri, { pushState })
        .then(response => {
          if (triggerEl) {
            triggerEl.removeAttribute('disabled');
          }
          renderContent(response.data, {
            triggerEl,
            autoScroll,
          });
        })
        .catch(err => {
          console.error(err);
          if (triggerEl) {
            triggerEl.removeAttribute('disabled');
          }
        });
    });
  
    window.addEventListener('popstate', () => {
      const uri = `${window.location.pathname}${window.location.search}`;
      CMS.DataStore.dispatch('product_filter/category', {
        uri,
        triggerEl: null,
        pushState: false,
      });
    });

  }
});

/**
 * Render content
 * 
 * @param {object} data - Data from backend
 * @param {object} options - Optional settings
 * 
 * @returns {void}
 */
const renderContent = (data, options = {}) => {
  const _defaults = {
    triggerEl: null,
  };
  const opts = { ..._defaults, ...options };

  const numActiveFilters = countCheckedParamFilters(data.parameters);

  // update meta title
  if (
    typeof data.tpl !== 'undefined' && 
    typeof data.tpl.meta_title !== 'undefined' && 
    data.tpl.meta_title !== ''
  ) {
    document.title = data.tpl.meta_title;
  }

  // breadcrumbs
  const breadcrumbsWrapEl = document.querySelector('[data-slot-breadcrumbs]');
  if (breadcrumbsWrapEl && data.tpl.breadcrumbs_html) {
    breadcrumbsWrapEl.innerHTML = data.tpl.breadcrumbs_html;
  }

  // product list featured image
  const productListFeaturedEl = document.querySelector('[data-slot-product-list-image]');
  if (productListFeaturedEl) {
    let pageHeaderImg = null;
    let pageHeaderImgMobile = null;

    if (data.header_img.file_id) {
      pageHeaderImg = {
        ...data.header_img.full,
        alt: data.header_img.alt,
      };
    }
    if (data.header_img_mobile.file_id) {
      pageHeaderImgMobile = {
        ...data.header_img_mobile.full,
        alt: data.header_img_mobile.alt,
      };
    }

    switchProductListFeaturedImage(productListFeaturedEl, {
      // header_img: data.header_img,
      // header_img_mobile: data.header_img_mobile,
      header_img: pageHeaderImg,
      header_img_mobile: pageHeaderImgMobile,
    });
  }

  // product list title
  const productListTitleEl = document.querySelector('[data-slot-product-list-title]');
  if (productListTitleEl) {
    productListTitleEl.innerHTML = `${data.title} <span class="text-dark">(${data.products.total})</span>`;
  }

  // product list filter trigger button (mobile)
  const btnFilterOpenEl = document.querySelector('[data-open-product-list-filter]');
  if (btnFilterOpenEl) {
    if (numActiveFilters === 0) {
      btnFilterOpenEl.classList.remove('btn-primary');
      btnFilterOpenEl.classList.add('btn-light');
    } else {
      btnFilterOpenEl.classList.remove('btn-light');
      btnFilterOpenEl.classList.add('btn-primary');
    }
    btnFilterOpenEl.querySelector('span').textContent = (numActiveFilters === 0) ? Settings.webshop.i18n.list_filter_btn_empty_label : formatText(Settings.webshop.i18n.list_filter_btn_label, [numActiveFilters]);
  }

  // product list content
  const productListEl = document.querySelector('[data-slot-product-list]');
  let introData = null;
  if (typeof data.intro !== 'undefined' && typeof data.intro.content !== 'undefined') {
    introData = contentToCollapse(data.intro.content, {
      collapseId: 'infoBlockContent',
    });
  }
  const productListHtml = tplWebshopProductList({
    i18n: {
      ...Settings.webshop.i18n,
      btn_collapse_label: Settings.general.i18n.btn_collapse_label,
    },
    list: data.products.list,
    intro: (typeof data.intro !== 'undefined') ? data.intro : null,
    introData,
    numActiveFilters,
    pager_html: data.pager_html,
    productNoimageHtml: cmsNoImage('square', {
      theme: 'dark',
      classname: 'd-block w-auto h-auto mw-100 mh-224px',
      alt: Settings.general.i18n.alt_noimage,
    }),
  });
  productListEl.innerHTML = productListHtml;

  // product list filter content

  // count checked filter items
  data.parameters.map(paramGroup => {
    let totalChecked = 0;
    paramGroup.parameters.forEach(param => {
      if (param.checked) {
        totalChecked ++;
      }
    });
    paramGroup.total_checked = totalChecked;
    return paramGroup;
  });

  const productListFilterEl = document.querySelector('[data-slot-product-list-filter]');
  const productListFilterHtml = tplWebshopProductFilter({
    i18n: Settings.webshop.i18n,
    categories: data.categories,
    parameters: data.parameters,
    filterCollapseState,
  });
  productListFilterEl.innerHTML = productListFilterHtml;

  // check for trigger el in new DOM & autofocus
  if (opts.triggerEl) {
    const triggerEl = (opts.triggerEl.hasAttribute('id')) ? document.getElementById(opts.triggerEl.getAttribute('id')) : null;
    if (triggerEl) {
      triggerEl.focus();
    }
  }

  // product filter event listeners
  setFilterListeners();

};

/**
 * Set product list filter event listeners
 * 
 * @returns {void}
 */
const setFilterListeners = (options = {}) => {
  const _defaults = {
    parent: '[data-slot-product-list-filter]',
    btnTopLevel: '[data-btn-category-top-level]',
    pager: '[data-slot-product-list-pager]',
  };
  const opts = { ..._defaults, ...options };

  const parentEl = (typeof opts.parent === 'string') ? document.querySelector(opts.parent) : opts.parent;
  if (!parentEl) {
    return;
  }
  const btnTopLevel = (typeof opts.btnTopLevel === 'string') ? parentEl.querySelector(opts.btnTopLevel) : opts.btnTopLevel;

  // category radio change events
  Array.from(parentEl.querySelectorAll('[name="kategoria"]')).forEach(inputEl => {
    inputEl.addEventListener('change', e => {
      const isChecked = e.target.checked;
      const categorySlug = e.target.value;
      if (isChecked) {
        CMS.DataStore.dispatch('product_filter/category', {
          uri: `/${categorySlug}`,
          triggerEl: e.target,
        });
      }
    });
  });

  // top level category button click event
  if (btnTopLevel) {
    btnTopLevel.addEventListener('click', e => {
      e.preventDefault();

      const uri = btnTopLevel.getAttribute('href');
      CMS.DataStore.dispatch('product_filter/category', {
        uri,
        triggerEl: btnTopLevel,
      });
    });
  }

  // parameter checkbox change events
  Array.from(parentEl.querySelectorAll('[name="parameters[]"]')).forEach(inputEl => {
    inputEl.addEventListener('change', e => {
      const formEl = inputEl.closest('[data-product-list-filter]');
      const uri = formEl.getAttribute('action');
      const queryString = decodeURIComponent(new URLSearchParams(new FormData(formEl)).toString());
      CMS.DataStore.dispatch('product_filter/category', {
        uri: `${uri}${(queryString) ? '?' + queryString : ''}`,
        triggerEl: e.target,
      });
    });
  });

  // reset parameter group filter
  Array.from(parentEl.querySelectorAll('[data-product-list-filter-reset]')).forEach(btnEl => {
    btnEl.addEventListener('click', e => {
      e.preventDefault();
      const paramGroupId = btnEl.getAttribute('data-product-list-filter-reset');
      const formEl = parentEl.querySelector('[data-product-list-filter]');
      Array.from(formEl.querySelectorAll(`input[data-param-group-id="${paramGroupId}"]`)).forEach(inputEl => inputEl.checked = false);

      const uri = formEl.getAttribute('action');
      const queryString = decodeURIComponent(new URLSearchParams(new FormData(formEl)).toString());
      CMS.DataStore.dispatch('product_filter/category', {
        uri: `${uri}${(queryString) ? '?' + queryString : ''}`,
        triggerEl: e.target,
      });
    }, false);
  });

  // clear all parameter filters
  Array.from(document.querySelectorAll('[data-clear-filter-form]')).forEach(btnEl => {
    btnEl.addEventListener('click', e => {
      e.preventDefault();
      const formEl = parentEl.querySelector(btnEl.getAttribute('data-clear-filter-form'));
      Array.from(formEl.querySelectorAll('[type="checkbox"]')).forEach(cbEl => cbEl.checked = false);
      
      const uri = formEl.getAttribute('action');
      const queryString = decodeURIComponent(new URLSearchParams(new FormData(formEl)).toString());
      CMS.DataStore.dispatch('product_filter/category', {
        uri: `${uri}${(queryString) ? '?' + queryString : ''}`,
        triggerEl: e.target,
      });

      // auto-close filter on mobile:
      if (window.innerWidth < 992) {
        const filterPanelEl = document.querySelector('[data-slot-product-list-filter]');
        closeFilterPanel(filterPanelEl);
      }

    }, false);
  });

  // product list filter open / close (mobile)
  const btnFilterOpenEl = document.querySelector('[data-open-product-list-filter]');
  const btnFilterCloseEl = document.querySelector('[data-close-product-list-filter]');
  
  if (btnFilterOpenEl) {
    btnFilterOpenEl.addEventListener('click', e => {
      e.preventDefault();
      const filterPanelEl = document.querySelector('[data-slot-product-list-filter]');
      openFilterPanel(filterPanelEl);
    }, false);
  }
  if (btnFilterCloseEl) {
    btnFilterCloseEl.addEventListener('click', e => {
      e.preventDefault();
      const filterPanelEl = document.querySelector('[data-slot-product-list-filter]');
      closeFilterPanel(filterPanelEl);
    }, false);
  }

  // product list filter collapse elements:
  Array.from(parentEl.querySelectorAll('[data-bs-toggle="collapse"]')).forEach(btnEl => {
    btnEl.addEventListener('click', e => {
      const panelId = btnEl.getAttribute('aria-controls');
      const isExpanded = (btnEl.getAttribute('aria-expanded') === 'true') ? true : false;
      filterCollapseState[panelId] = isExpanded;
    }, false);
  });

  // product list pagination
  if (document.querySelector(opts.pager)) {
    Array.from(document.querySelectorAll(`${opts.pager} a`)).forEach(linkEl => {
      linkEl.addEventListener('click', e => {
        e.preventDefault();
        const uri = linkEl.getAttribute('href');
        CMS.DataStore.dispatch('product_filter/category', {
          uri,
          triggerEl: linkEl,
          autoScroll: true,
        });
      }, false);
    });
  }

};
